import type { AuthModalProps as AuthModalBaseProps } from '@pique/component/auth-components';
import { AuthModal as AuthModalBase } from '@pique/component/auth-components';
import type { FC } from 'react';
import { useCallback } from 'react';

import { SignIn } from './sign-in';

export type AuthProps = {
  state: 'signIn';
  onSignedIn?: () => void;
  persistent?: boolean;
};

export type AuthPanelProps = {
  onSignedIn?: () => void;
};

export const AuthModal: FC<AuthModalBaseProps & AuthProps> = ({
  open,
  setOpen,
  onSignedIn,
  persistent = false,
}) => {
  const handleSignedIn = useCallback(() => {
    setOpen(false);
    onSignedIn?.();
  }, [setOpen, onSignedIn]);

  return (
    <AuthModalBase open={open} setOpen={setOpen} persistent={persistent}>
      <SignIn onSignedIn={handleSignedIn} />
    </AuthModalBase>
  );
};

export const AuthPanel: FC<AuthProps> = ({ onSignedIn }) => {
  return <SignIn onSignedIn={onSignedIn} />;
};
